module.exports = __webpack_public_path__ + "static/media/CrushLogo-2019.fa45e4d9.png";